module.exports = __webpack_public_path__ + "img/07.fe2a5680.png";